import React from "react";

interface UserLayoutProps {
  children: React.ReactNode;
}

const UserLayout: React.FC<UserLayoutProps> = ({ children }): JSX.Element => {
  // User layout - no B2B header, just clean layout
  return (
    <div>
      {children}
    </div>
  );
};

export default UserLayout;
